<template>
  <div class="p-4 max-w-3xl mx-auto">
    <!-- Header Image -->
    <div class="flex justify-center items-center">
      <img
        class="w-96 h-auto"
        :src="require('@/assets/IMF-header.png')"
        alt="Header"
      />
    </div>

    <!-- Title -->
    <div class="text-center mb-10">
      <h1 class="text-2xl text-zinc-600 font-medium">Test Request</h1>
    </div>
    <div class="flex justify-between mb-3">
      <div @click="currentShowFilter = 'main'" class="cursor-pointer">
        Main Category
      </div>
      <div @click="currentShowFilter = 'container'" class="cursor-pointer">
        Done
      </div>
    </div>

    <div class="space-y-2">
      <div class="relative w-full">
        <input
          v-model="inputProcedure"
          @focus="onFocus"
          @input="searchHandler()"
          placeholder="Choose Test Request"
          type="text"
          class="peer w-full text-base font-medium bg-white text-gray-800 rounded-lg px-2 pr-10 pt-2 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
          required
        />
        <HeartAddItem
          v-show="isCurrentFocus"
          @click="addItemProcedure()"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-orange-500 cursor-pointer"
        />
      </div>

      <!-- Categories -->
      <div class="pt-2" v-if="currentShowFilter === 'main'">
        <ul
          class="bg-white px-2 py-2 space-y-2 rounded-md shadow-[rgba(60,64,67,0.3)_0px_1px_2px_0px,rgba(60,64,67,0.15)_0px_1px_3px_1px]"
        >
          <li class="text-xs text-zinc-500">
            {{ currentShowFilter === "main" ? "Category" : currentShowTitle }}
          </li>
          <li
            v-for="item in ItemtestCategories"
            :key="item.id"
            @click="handlerRouteProcedure(item)"
            class="text-zinc-700 px-4 py-2 rounded-md hover:bg-zinc-200 cursor-pointer"
          >
            {{ item.category }}
          </li>
        </ul>
      </div>

      <!-- Procedures -->
      <div
        class="pt-2"
        v-else-if="
          currentShowFilter === 'procedure' ||
          currentShowFilter === 'search-procedure'
        "
      >
        <ul
          class="bg-white px-2 py-2 space-y-2 rounded-md shadow-[rgba(60,64,67,0.3)_0px_1px_2px_0px,rgba(60,64,67,0.15)_0px_1px_3px_1px]"
        >
          <li
            class="text-xs text-zinc-500"
            v-if="currentShowFilter === 'search-procedure'"
          >
            Total Number Result: {{ ItemtestProcedures.length }}
            {{ ItemtestProcedures.length === 1 ? "result" : "results" }}
          </li>
          <span class="text-xs" v-show="currentShowFilter === 'procedure'">{{
            currentShowTitle
          }}</span>
          <li
            v-for="item in ItemtestProcedures"
            :key="item.id"
            class="flex items-center px-2 py-2 rounded-md hover:bg-zinc-200 cursor-pointer"
            @click="toggleProcedure(item)"
          >
            <input
              type="checkbox"
              class="mr-2 w-5 h-5 rounded-full border-2 border-zinc-400 appearance-none checked:bg-orange-500 checked:border-orange-500 focus:outline-none cursor-pointer transition-all"
              :checked="isSelected(item)"
              @click.stop
            />
            <span class="text-zinc-700 text-sm">{{ item.procedures }}</span>
          </li>
        </ul>
      </div>

      <!-- Selected Procedures -->
      <div class="pt-2" v-else>
        <div
          v-for="(items, category) in groupedItems"
          :key="category"
          class="mb-4 space-y-1"
        >
          <h3 class="font-bold text-sm text-zinc-600">{{ category }}</h3>
          <ul class="ml-4">
            <li
              v-for="item in items"
              :key="item.id"
              class="text-base text-zinc-700 my-2 flex justify-between items-center"
            >
              <span>{{ item.procedures }}</span>
              <span
                @click="removeProcedure(category, item)"
                class="cursor-pointer"
              >
                <DeleteItemSvg />
              </span>
            </li>
          </ul>
        </div>

        <!-- Optional Actions -->
        <div class="mt-6 mb-3">
          <h3 class="text-zinc-500">Optional Action</h3>
          <ul class="my-3 flex gap-4 justify-center items-center">
            <li
              @click="isShowRemarks = !isShowRemarks"
              class="text-xs flex gap-2 items-center justify-center"
            >
              <AddItemSvg /> Remarks
            </li>
            <li
              @click="isShowFollowUp = !isShowFollowUp"
              class="text-xs flex gap-2 items-center justify-center"
            >
              <AddItemSvg /> Follow up date
            </li>
            <li
              @click="isShowDiagnosis = !isShowDiagnosis"
              class="text-xs flex gap-2 items-center justify-center"
            >
              <AddItemSvg /> Diagnosis
            </li>
          </ul>
        </div>
        <div class="space-y-2">
          <div class="space-y-2" v-show="isShowRemarks">
            <h3 class="text-sm font-bold text-zinc-600">Remarks</h3>
            <textarea
              v-model="addOptionRemarks"
              cols="4"
              rows="4"
              placeholder="Add Remarks"
              type="text"
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-lg px-2 pt-2 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
            />
          </div>
          <div class="space-y-2" v-show="isShowFollowUp">
            <h3 class="text-sm font-bold text-zinc-600">Follow up date</h3>
            <input
              v-model="addOptionFollowup"
              type="date"
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-lg px-2 pt-2 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
            />
          </div>
          <div class="space-y-2" v-show="isShowDiagnosis">
            <h3 class="text-sm font-bold text-zinc-600">Diagnosis</h3>
            <textarea
              v-model="addOptionDiagnosis"
              cols="2"
              rows="2"
              placeholder="Add Diagnosis"
              type="text"
              class="peer w-full text-base font-medium bg-white text-gray-800 rounded-lg px-2 pt-2 pb-2 border border-gray-300 appearance-none focus:outline-none focus:ring-2 focus:ring-orange-400 shadow-sm focus:shadow-orange-300 transition duration-300"
            />
          </div>
        </div>
        <div class="my-4 space-y-2">
          <button
            @click="SendToPatient()"
            type="submit"
            class="w-full py-3 bg-primary hover:bg-hover text-white font-semibold rounded-lg transition duration-200 flex items-center justify-center"
          >
            Send to Patient
          </button>
          <button
            type="submit"
            class="w-full py-3 bg-black hover:bg-zinc-700 text-white font-semibold rounded-lg transition duration-200 flex items-center justify-center"
          >
            Save as Template
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, onMounted, ref } from "vue";
import AddItemSvg from "@/components/svgs/AddItemSvg.vue";
import DeleteItemSvg from "@/components/svgs/DeleteItemSvg.vue";
import HeartAddItem from "@/components/svgs/HeartAddSvg.vue";
import { useRoute } from "vue-router";
import pdfReferralGenerateHandler from "@/utils/testreferral";
export default {
  components: {
    HeartAddItem,
    AddItemSvg,
    DeleteItemSvg,
  },
  setup() {
    const { exportReferralPDF } = pdfReferralGenerateHandler();
    const swal = inject("$swal");
    const axios = inject("$axios");
    const route = useRoute();
    const isCurrentFocus = ref(false);
    const ItemtestCategories = ref([]);
    const ItemtestProcedures = ref([]);
    const selectedTestProcedures = ref([]);
    const currentShowFilter = ref("main");
    const currentShowTitle = ref("Categories");
    const inputProcedure = ref("");
    const isShowRemarks = ref(false);
    const isShowFollowUp = ref(false);
    const isShowDiagnosis = ref(false);
    const addOptionRemarks = ref();
    const addOptionFollowup = ref();
    const addOptionDiagnosis = ref();

    onMounted(() => {
      console.log();
      getTestCategories();
    });

    const getTestCategories = async () => {
      try {
        const categoriesResponse = await axios.get(
          "/api/doctor/data-entry/test-request/category"
        );
        if (categoriesResponse?.data?.data) {
          ItemtestCategories.value = categoriesResponse.data.data;
        }
      } catch (error) {
        console.error("Error fetching test categories:", error);
      }
    };

    const handlerRouteProcedure = (item) => {
      currentShowFilter.value = "procedure";
      currentShowTitle.value = item.category;
      ItemtestProcedures.value = item.telemed_test_procedures.map((p) => ({
        ...p,
        id: p.id,
      }));
    };

    const toggleProcedure = (item) => {
      inputProcedure.value = "";
      const index = selectedTestProcedures.value.findIndex(
        (p) => p.item.id === item.id
      );

      if (index === -1) {
        selectedTestProcedures.value.push({
          category:
            currentShowFilter.value === "search-procedure"
              ? item.telemed_test_category.category
              : currentShowTitle.value,
          item: item,
        });
      } else {
        selectedTestProcedures.value.splice(index, 1);
      }
    };

    const isSelected = (item) => {
      return selectedTestProcedures.value.some((p) => p.item.id === item.id);
    };

    const groupedItems = computed(() => {
      return selectedTestProcedures.value.reduce((acc, curr) => {
        if (!acc[curr.category]) {
          acc[curr.category] = [];
        }
        acc[curr.category].push(curr.item);
        return acc;
      }, {});
    });

    const onFocus = () => {
      isCurrentFocus.value = true;
      if (
        currentShowFilter.value !== "main" &&
        currentShowFilter.value !== "procedure"
      ) {
        currentShowFilter.value = "main";
      }
    };

    const searchHandler = async () => {
      currentShowFilter.value = "search-procedure";
      const search = inputProcedure.value?.toLowerCase().trim();

      if (!search) {
        currentShowFilter.value = "main";
        return;
      }

      try {
        const proceduresResponse = await axios.get(
          `/api/doctor/data-entry/test-request/procedures/${encodeURIComponent(
            search
          )}`
        );
        ItemtestProcedures.value = proceduresResponse?.data?.data || [];
      } catch (error) {
        console.error("Error fetching procedures:", error);
        ItemtestProcedures.value = [];
      }
    };

    // Remove selected procedure
    const removeProcedure = (category, item) => {
      const index = selectedTestProcedures.value.findIndex(
        (p) => p.item.id === item.id && p.category === category
      );
      if (index !== -1) {
        selectedTestProcedures.value.splice(index, 1);
      }
    };
    const SendToPatient = async () => {
      try {
        const confirm = await swal.fire({
          icon: "question",
          title: "Are you sure?",
          text: "Do you want to send the selected test procedures to the patient?",
          showCancelButton: true,
          confirmButtonText: "Yes, send it!",
          cancelButtonText: "No, cancel",
        });

        if (!confirm.isConfirmed) return;

        const result = selectedTestProcedures.value.map((d) => ({
          transactionid: route.params.id,
          category: d.category,
          procedures: d.item.procedures,
          remarks: addOptionRemarks.value,
          followupdate: addOptionFollowup.value,
          diagnosis: addOptionDiagnosis.value,
        }));

        const insertResponse = await axios.post(
          "/api/doctor/data-entry/test-request/procedures",
          result
        );

        if (insertResponse.data.success) {
          await swal.fire({
            icon: "success",
            title: "Successfully Sent!",
            html: "The selected test procedures have been sent to the patient.",
            confirmButtonText: "OK",
          });

          await downloadTestProcedureHandler();
        }
      } catch (error) {
        console.error("❌ Error inserting procedures:", error);
      }
    };

    const addItemProcedure = async () => {
      try {
        const { data } = await axios.post(
          "/api/doctor/data-entry/test-request/category/procedures",
          { procedures: inputProcedure.value }
        );

        // Assuming your backend returns the inserted procedure like:
        // { id, categoryid, procedures, telemed_test_category: { id, category } }
        const newProcedure = data.data; // from backend response

        // Then push to selectedTestProcedures in your desired format:
        selectedTestProcedures.value.push({
          category:
            newProcedure.telemed_test_category?.category || "Uncategorized",
          item: newProcedure,
        });

        // Optionally clear the input after adding
        inputProcedure.value = "";

        currentShowFilter.value = "container";
        console.log("✅ Added:", newProcedure);
      } catch (error) {
        console.error("❌ Error inserting procedures:", error);
      }
    };
    const downloadTestProcedureHandler = async () => {
      try {
        console.log("Route", route.params.id);
        const { data } = await axios.get(
          `/api/doctor/consultation/history/test-procedure/${route.params.id}`
        );
        let respond = data.data;
        await exportReferralPDF(respond);
        //window.close();
      } catch (error) {
        console.log(error);
      }
    };
    return {
      ItemtestCategories,
      ItemtestProcedures,
      currentShowFilter,
      currentShowTitle,
      selectedTestProcedures,
      groupedItems,
      toggleProcedure,
      isSelected,
      handlerRouteProcedure,
      getTestCategories,
      onFocus,
      searchHandler,
      inputProcedure,
      removeProcedure,
      isShowRemarks,
      isShowFollowUp,
      isShowDiagnosis,
      SendToPatient,
      addOptionRemarks,
      addOptionFollowup,
      addOptionDiagnosis,
      addItemProcedure,
      isCurrentFocus,
      downloadTestProcedureHandler,
    };
  },
};
</script>
